var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wallet-picker-window',{ref:"window",staticClass:"walletpicker",attrs:{"wallets":_vm.wallets,"title":_vm.$t('walletpicker.connectToWallet')},on:{"wallet-pick":_vm.onWalletPick,"window-hide":_vm.onWindowHide}})
}
var staticRenderFns = []

export { render, staticRenderFns }